/** Defines the React context for the authentication state. */
// @ts-check
import { createContext } from 'react';

/** @type {import('react').Context<AuthContextValue | null>} */
export const AuthContext = createContext(null);
